export class CreateLicenceResponseDto {
    LicenceCode: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/licencing/create-licence-response.dto.ts